import type { Meta, StoryObj } from "@storybook/react";

import type { UserTabSelectorProps } from "@/ui/core";
import { UserTabSelector } from "@/ui/core";

const StoryMeta: Meta<UserTabSelectorProps> = {
  title: "Core/User Tab Selector",
  component: UserTabSelector,
  argTypes: {
    accessibilityLabel: { control: "text" },
    appUserId: { control: "text" },
    onUserChange: { action: "User changed" },
    tabs: { control: "object" },
    testID: { control: "text" },
  },
  args: {
    accessibilityLabel: "storybook user-selector",
    appUserId: "jessica_001",
    tabs: [
      {
        badgeCount: 4,
        userId: "jessica_001",
        userName: "Jessica",
      },
      {
        badgeCount: 1,
        userId: "lee_002",
        userName: "Lee",
      },
      {
        badgeCount: 10,
        userId: "caroline_003",
        userName: "Caroline",
      },
    ],
    testID: "storybook",
  },
};

type Story = StoryObj<UserTabSelectorProps>;

export const Primary: Story = {};
export default StoryMeta;
